export default "__VITE_ASSET__CWzwcVOX__"